import React, { useEffect, useState, useRef } from 'react'
import search_img from '../../../images/main/search.svg'
import banner from '../../../images/listing/banner.png'
// import bannerHh from '../../../images/main/hh.jpg'
import form_image from '../../../images/listing/form_image.png'
import circle from '../../../images/main/curcle.svg'
import cross from '../../../images/listing/krest.svg'

import { useForm, Controller } from 'react-hook-form'
import { useSearchParams } from "react-router-dom";
import FormVacation from './form/FormVacation'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

import styles from './styles.module.scss'
import './select_custom.css'
import smoothscroll from 'smoothscroll-polyfill'
import Select, { components } from "react-select";
import students from "../../../images/main/students.jpg";
import vector_right from "../../../images/basic/header/vector_right.svg";

const Listing = ({
     filterVacation,
     searchMainInput,
     setSearchMainInput,
     checkDomenNameState,
     ourRef,
     setInfoVacationRetakePage,
     infoVacationRetakePage,
     captchaSiteKey
   }) => {
  smoothscroll.polyfill()
  const _domenWork = 'career.generium.ru'
  const [departaments, setDepartaments] = useState([])
  const [directions, setDirections] = useState([])
  const [cites, setСities] = useState([])
  const [notOpenVacation, setNotOpenVacation] = useState(false)
  const [allVacationNoSort, setAllVacationNoSort] = useState([])
  const [vacationSort, setVacationSort] = useState([])
  const [searchSuccess, setSearchSuccess] = useState(false)
  const [currentSizeNoSort, setCurrentSizeNoSort] = useState(3)
  const [startVacation, setStartVacation] = useState(6)
  const [infoCurrent, setInfoCurrent] = useState('')
  const [totalCurrent, setTotalCurrent] = useState(6)
  const [successForm, setSuccessForm] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [infoDataFilter, setInfoDataFilter] = useState(infoVacationRetakePage)
  const [infoCity, setInfoCity] = useState('')
  const [infoLocation, setInfoLocation] = useState('')
  const [infoDirection, setInfoDirection] = useState('')
  const [infoEmploymentType, setInfoEmploymentType] = useState('')
  const [infoIsRemote, setInfoIsRemote] = useState('')
  const [closeBtnDep, setCloseBtnDep] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();

  let _protocol = window.location.protocol

  if (window.location.hostname.indexOf(_domenWork) != -1) {
    checkDomenNameState = window.location.hostname
  }

  // setting form - inputs
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onSubmit'
  })
  const getAllCities = async () => {
    try {
      const result = await axios({
        method: 'get',
        url: `${_protocol}//${checkDomenNameState}/api/v1/unit/cities`
      })
      setСities(result.data)
    } catch (e) {
      toast.error('Ошибка загрузки списка городов')
    }
  }
  const getActiveDepartaments = async () => {
    try {
        const result = await axios({
          method: 'get',
          url: `${_protocol}//${checkDomenNameState}/api/v1/unit/names`
        })
        setDepartaments(result.data)
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    }
  }

  const getActiveDirections = async () => {
    try {
      const result = await axios({
        method: 'get',
        url: `${_protocol}//${checkDomenNameState}/api/v1/unit/direction`
      })
      setDirections(result.data)
    } catch (e) {
      toast.error('Ошибка загрузки направлений')
    }
  }

  // Получение стартовых вакансий без фильтра
  const getAllVacation = async () => {
    setCloseBtnDep(false)
    setCurrentSizeNoSort(3)
    setInfoVacationRetakePage({})
    try {
      const result = await axios({
        method: 'get',
        url: `${_protocol}//${checkDomenNameState}/api/v1/unit`
      })
      setAllVacationNoSort(result.data)

      let totalPage = 0
      for (let i of result.data) {
        totalPage = totalPage + i.positionCount
      }

      setTotalCurrent(totalPage)
      setInfoCurrent(totalPage)
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    }
  }

  const getVacationByFilterGet = async queryParams => {
    let positionName;
    let positionNameConType;
    if (queryParams?.positionName) {
      positionName = `positionName=${queryParams.positionName}`;
      positionNameConType = '&positionNameConType=CONTAINS_SUBSTR';
      setValue('positionName', queryParams?.positionName)
    } else {
      positionName = '';
      positionNameConType = '';
    }

    let city;
    let cityCondType;
    if (queryParams?.city) {
      city = `&city=${queryParams?.city}`;
      cityCondType = '&cityCondType=CONTAINS_SUBSTR';
      selectInputRefCities.current.props.onChange({value: queryParams?.city});
    } else {
      city = '';
      cityCondType = '';
    }

    let unitName;
    let unitNameConType;
    if (queryParams?.unitName) {
      unitName = `&unitName=${queryParams?.unitName}`;
      unitNameConType = '&unitNameConType=EQ';
      selectInputRefDepartaments.current.props.onChange({value: queryParams?.unitName});
    } else {
      unitName = '';
      unitNameConType = '';
    }

    let unitDirectionName;
    let unitDirectionNameConType;
    if (queryParams?.unitDirectionName) {
      unitDirectionName = `&unitDirectionName=${queryParams?.unitDirectionName}`;
      unitDirectionNameConType = '&unitDirectionNameConType=EQ';
      selectInputRefDirections.current.props.onChange({value: queryParams?.unitDirectionName});
    } else {
      unitDirectionName = '';
      unitDirectionNameConType = '';
    }

    let employmentType;
    let employmentTypeConType;
    if (queryParams?.employmentType) {
      employmentType = `&employmentType=${queryParams?.employmentType}`;
      employmentTypeConType = '&employmentTypeConType=EQ';
      selectInputRefEployment.current.props.onChange({value: queryParams?.employmentType});
    } else {
      employmentType = '';
      employmentTypeConType = '';
    }

    if (positionName === true && city === '' && unitName === '' && unitDirectionName === '' && employmentType === '') {
      try {
      const result = await axios({
        method: 'get',
        url: `${_protocol}//${checkDomenNameState}/api/v1/unit`
      })
      setAllVacationNoSort(result.data)
      setInfoVacationRetakePage({})

      let totalPage = 0
      for (let i of result.data) {
        totalPage = totalPage + i.positionCount
      }

      setTotalCurrent(totalPage)
      setInfoCurrent(totalPage)
      } catch (e) {
        toast.error('Ошибка загрузки вакансий')
      }
    } else {
      try {
      const result = await axios({
        method: 'post',
        url: `${_protocol}//${checkDomenNameState}/api/v1/position?${positionName}${city}${unitName}${unitDirectionName}${employmentType}&isRemote=${queryParams.isRemote}${positionNameConType}${cityCondType}${unitNameConType}${unitDirectionNameConType}${employmentTypeConType}&isRemoteConType=EQ&sort=updateDate&page=0&size=${totalCurrent}`
      })

      setVacationSort(result.data.content)
      setSearchSuccess(true)
      setInfoCurrent(result.data.totalElements)
      setTotalCurrent(result.data.totalElements)
      setInfoDataFilter({
        positionName: positionName,
        positionNameConType: positionNameConType,
        city: city,
        cityCondType: cityCondType,
        unitName: unitName,
        unitDirectionName: unitDirectionName,
        unitNameConType: unitNameConType,
        unitDirectionNameConType: unitDirectionNameConType,
        employmentType: employmentType,
        employmentTypeConType: employmentTypeConType,
        isRemote: queryParams.isRemote
      })

      if (result.data.content.length === result.data.totalElements) {
        setDisableBtn(true)
      }
      setInfoVacationRetakePage(infoDataFilter)

      setInfoCity(queryParams?.city)
      setInfoLocation(queryParams?.unitName)
      setInfoDirection(queryParams?.unitDirectionName)
      setInfoEmploymentType(queryParams?.employmentType)
      setInfoIsRemote(queryParams?.isRemote)

      setTotalCurrent(result.data.totalElements)
      setInfoCurrent(result.data.totalElements)
      } catch (e) {
        toast.error('Ошибка загрузки вакансий')
      }
    }
  }

  // получение вакансий при поиске через фильтр
  const onSearch = async data => {
    let positionName

    if (data?.positionName) {
      positionName = `positionName=${data.positionName}`
    } else {
      positionName = ''
    }

    let cityValue = document.querySelector('input[name="city"]').value;
    let city
    if (cityValue) {
      city = `&city=${cityValue}`
    } else {
      city = ''
    }
    let u = document.querySelector('input[name="unitName"]')
    let unitNameValue = '';
    if(u !== null) {
      unitNameValue = document.querySelector('input[name="unitName"]').value;
    }
    let unitName
    if (unitNameValue) {
      unitName = `&unitName=${unitNameValue}`
    } else {
      unitName = ''
    }

    let unitDirectionNameValue = document.querySelector('input[name="unitDirectionName"]').value;
    let unitDirectionName
    if (unitDirectionNameValue) {
      unitDirectionName = `&unitDirectionName=${unitDirectionNameValue}`
    } else {
      unitDirectionName = ''
    }

    let employmentTypeValue = document.querySelector('input[name="employment"]').value;
    let employmentType
    if (employmentTypeValue) {
      employmentType = `&employmentType=${employmentTypeValue}`
    } else {
      employmentType = ''
    }

    if (!watch('positionName') === true && city === '' && unitName === '' && unitDirectionName === '' && employmentType === '') {
      window.location.href = `${_protocol}//${checkDomenNameState}/listing`;
    } else {
      window.location.href = `${_protocol}//${checkDomenNameState}/listing?${positionName}${city}${unitName}${unitDirectionName}${employmentType}`;
    }
  }

  const clearFilter = async () => {
    window.location.href = `${_protocol}//${checkDomenNameState}/listing`;
  }

  // вызов фильтра при возвращении с страницы карточки
  const retakePageVacation = async data => {
    setCloseBtnDep(false)
    setCurrentSizeNoSort(3)
    setDisableBtn(false)
    try {
      const result = await axios({
        method: 'post',
        url: `${_protocol}//${checkDomenNameState}/api/v1/position?${infoVacationRetakePage.positionName}${infoVacationRetakePage.city.name}${infoVacationRetakePage.unitName}${infoVacationRetakePage.unitDirectionName}${infoVacationRetakePage.employmentType}&isRemote=${infoVacationRetakePage.isRemote}${infoVacationRetakePage.positionNameConType}${infoVacationRetakePage.cityCondType}${infoVacationRetakePage.unitNameConType}${infoVacationRetakePage.unitDirectionNameConType}${infoVacationRetakePage.employmentTypeConType}&isRemoteConType=EQ&sort=updateDate&page=0&size=6`
      })
      setVacationSort(result.data.content)
      setSearchSuccess(true)
      setTotalCurrent(result.data.totalElements)
      setInfoCurrent(result.data.totalElements)
      if (result.data.content.length === result.data.totalElements) {
        setDisableBtn(true)
      }
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    } finally {
      let totalCity = infoVacationRetakePage?.city.split('=')
      let totalPositionName = infoVacationRetakePage?.positionName.split('=')
      let totalUnitName = infoVacationRetakePage?.unitName.split('=')
      let totalunitDirectionName = infoVacationRetakePage?.unitDirectionName.split('=')
      let totalEmploymentType = infoVacationRetakePage?.employmentType.split('=')
      setInfoDataFilter({
        //   positionName: totalPositionName[1],
        //   positionNameConType: totalPositionName[1],
        city: 'Москва',
        //   cityCondType: infoVacationRetakePage.cityCondType,
        //   unitName: totalUnitName[1],
        //   unitNameConType: infoVacationRetakePage.unitNameConType,
        //   employmentType: totalEmploymentType[1],
        //   employmentTypeConType: infoVacationRetakePage.employmentTypeConType,
        //   isRemote: infoVacationRetakePage.isRemote
      })
      // setInfoVacationRetakePage(infoDataFilter)

      //setValue('city', 'Москва')
      setValue('isRemote', infoVacationRetakePage.isRemote)
      // setInfoLocation(data?.unitName)
      // setInfoEmploymentType(data?.employmentType)
      // setInfoIsRemote(data?.isRemote)
      // totalPositionName && setValue('positionName', totalPositionName[1])
      //
      // totalPositionName && setValue('positionName', totalPositionName[1])
      // totalCity && setValue('city', totalCity[1])
      // totalUnitName && setValue('unitName', totalUnitName[1])
      // totalEmploymentType && setValue('employmentType', totalEmploymentType[1])
      // setValue('isRemote', infoVacationRetakePage.isRemote)
    }
  }

  // добавление вакансий при клике на ПОКАЗАТЬ еще
  const getNewPageSort = async () => {
    setSearchSuccess(false)

    // Проверка условий для queryString

    let isRemote = watch('isRemote')

    let positionName = watch('positionName')
    let positionNameConType

    if (positionName) {
      positionName = `positionName=${positionName}`
      positionNameConType = '&positionNameConType=CONTAINS_SUBSTR'
    } else {
      positionName = ''
      positionNameConType = ''
    }

    let city = watch('city')
    let cityCondType
    if (city) {
      city = `&city=${city}`
      cityCondType = '&cityCondType=CONTAINS_SUBSTR'
    } else {
      city = ''
      cityCondType = ''
    }

    let unitName = watch('unitName')
    let unitNameConType
    if (unitName) {
      unitName = `&unitName=${unitName}`
      unitNameConType = '&unitNameConType=EQ'
    } else {
      unitName = ''
      unitNameConType = ''
    }

    let unitDirectionName = watch('unitDirectionName')
    let unitDirectionNameConType
    if (unitDirectionName) {
      unitDirectionName = `&unitDirectionName=${unitDirectionName}`
      unitDirectionNameConType = '&unitDirectionNameConType=EQ'
    } else {
      unitDirectionName = ''
      unitDirectionNameConType = ''
    }


    let employmentType = watch('employmentType')
    let employmentTypeConType
    if (employmentType) {
      employmentType = `&employmentType=${employmentType}`
      employmentTypeConType = '&employmentTypeConType=EQ'
    } else {
      employmentType = ''
      employmentTypeConType = ''
    }

    setDisableBtn(false)
    try {
      const result = await axios({
        method: 'post',
        url: `${_protocol}//${checkDomenNameState}/api/v1/position?${positionName}${city}${unitName}${unitDirectionName}${employmentType}&isRemote=${isRemote}${positionNameConType}${cityCondType}${unitNameConType}${unitDirectionNameConType}${employmentTypeConType}&isRemoteConType=EQ&sort=updateDate&page=0&size=${
          totalCurrent + 6
        }`
      })
      setVacationSort(result.data.content)
      setTotalCurrent(result.data.content.length)
      setInfoCurrent(result.data.content.length)
      if (result.data.content.length === totalCurrent) {
        setDisableBtn(true)
      }
      setSearchSuccess(true)
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    }
  }

  // При ненайденных вакансиям - увеличиваем список вакансий в инфо поле
  const plusVacationNoSort = () => {
    setCurrentSizeNoSort(prevState => prevState + 6)
  }

  // Для стартовых вакансий после загрузки, увеличиваем число вакансий
  const plusStartVacation = () => {
    setStartVacation(prevState => prevState + 6)
  }

  useEffect(() => {
    setSuccessForm(false)

    //Проверяем, есть ли get параметры для фильтрации
    if ([...searchParams.entries()].length > 0) {

      const searchAsObject = Object.fromEntries(
        [...searchParams.entries()]
      );

      getVacationByFilterGet(searchAsObject);

    } else if (searchMainInput.length > 0) {
      // Если фильтр использовали с main страницы и поиск по названию
      let positionName = searchMainInput
      let positionNameConType
      if (searchMainInput) {
        positionName = `positionName=${positionName}`
        positionNameConType = '&positionNameConType=CONTAINS_SUBSTR'
      } else {
        positionName = ''
        positionNameConType = ''
      }

      axios({
        method: 'post',
        url: `${_protocol}//${checkDomenNameState}/api/v1/position?${positionName}&isRemote=false${positionNameConType}&isRemoteConType=EQ&sort=updateDate&page=0&size=10`
      }).then(res => {
        setVacationSort(res.data.content)
        setSearchSuccess(true)
        setTotalCurrent(res.data.content.length)
        setInfoCurrent(res.data.content.length)
      })
      setValue('positionName', searchMainInput)
      setSearchMainInput('')
    } else if (
      infoVacationRetakePage.city ||
      infoVacationRetakePage.employmentType ||
      infoVacationRetakePage.positionName ||
      infoVacationRetakePage.unitName
    ) {
      retakePageVacation()
    } else {
      getAllVacation()
    }

    getAllCities()
    getActiveDepartaments()
    getActiveDirections()
  }, [])

  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])

  //поиск по подразделению вакансий из нефильтрованного списка
  const searchDepartaments = async item => {
    let unitName = item.unitName
    if (unitName) {
      window.location.href = `${_protocol}//${checkDomenNameState}/listing?unitName=${unitName}`;
    }
  }

  const searchDirections = async item => {
    let unitDirectionName = item.unitDirectionName
    if (unitDirectionName) {
      window.location.href = `${_protocol}//${checkDomenNameState}/listing?unitDirectionName=${unitDirectionName}`;
    }
  }
  //очистка инфо полей из фильтра, когда вакансия не найдена
  const deleteFieldCity = () => {
    setInfoCity('')
    selectInputRefCities.current.props.onChange([]);
  }
  const deleteFieldDirection = () => {
    setInfoDirection('')
    selectInputRefDirections.current.props.onChange([]);
  }
  const deleteFieldLocation = () => {
    setInfoLocation('')
    selectInputRefDepartaments.current.props.onChange([]);
  }
  const deleteFieldEmploymentType = () => {
    setInfoEmploymentType('')
    selectInputRefEployment.current.props.onChange([]);
  }
  const deleteFieldIsRemote = () => {
    setInfoIsRemote('')
    selectInputRefCities.current.props.onChange([]);
  }

  //Кастомный селект
  const InputOption = ({
       getStyles,
       Icon,
       isDisabled,
       isFocused,
       isSelected,
       children,
       innerProps,
       ...rest
     }) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex "
    };

    // prop assignment
    const props = {
      ...innerProps,
      onMouseDown,
      onMouseUp,
      onMouseLeave,
      style
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isFocused={isFocused}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input type="checkbox" checked={isSelected} />
        {children}
      </components.Option>
    );
  };

  const citiesSelect = [{value: '', label: 'Все города'}];
  const departmentsSelect = [{value: '', label: 'Все подразделения'}];
  const directionsSelect = [{value: '', label: 'Все направления'}];
  const eploymentSelect = [
    {value: '', label: 'Любой'},
    {value: 'Полная занятость', label: 'Полная занятость'},
    {value: 'Частичная', label: 'Частичная'},
    {value: 'Проектная', label: 'Проектная'},
    {value: 'Стажировка', label: 'Стажировка'},
  ];

  cites.forEach(item => {
    citiesSelect.push({value: item, label: item});
  })

  directions.forEach(item => {
    directionsSelect.push({value: item, label: item});
  })

  departaments.forEach(item => {
    departmentsSelect.push({value: item, label: item});
  })

  const { control } = useForm();

  const selectInputRefCities = useRef();
  const selectInputRefEployment = useRef();
  const selectInputRefDepartaments = useRef();
  const selectInputRefDirections = useRef();

  const onClear = () => {
    selectInputRefCities.current.props.onChange([]);
    selectInputRefEployment.current.props.onChange([]);
    selectInputRefDepartaments.current.props.onChange([]);
    selectInputRefDirections.current.props.onChange([]);
  };
  const unitNameShow = false;
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_title}>
        <div className={styles.title_left}></div>
        <p className={styles.main_title}>
          Сейчас открыт
          {totalCurrent === 1 ||
          totalCurrent === 21 ||
          totalCurrent === 31 ||
          totalCurrent === 41 ||
          totalCurrent === 51 ||
          totalCurrent === 61 ||
          totalCurrent === 71 ||
          totalCurrent === 81 ||
          totalCurrent === 91 ||
          totalCurrent === 101 ||
          totalCurrent === 121 ||
          totalCurrent === 131 ||
          totalCurrent === 141 ||
          totalCurrent === 151
            ? 'а'
            : 'о'}{' '}
          {infoCurrent} ваканс
          {totalCurrent === 1 ||
          totalCurrent === 21 ||
          totalCurrent === 31 ||
          totalCurrent === 41 ||
          totalCurrent === 51 ||
          totalCurrent === 61 ||
          totalCurrent === 71 ||
          totalCurrent === 81 ||
          totalCurrent === 91 ||
          totalCurrent === 101 ||
          totalCurrent === 121 ||
          totalCurrent === 131 ||
          totalCurrent === 141 ||
          totalCurrent === 151
            ? 'ия'
            : totalCurrent === 2 ||
            totalCurrent === 3 ||
            totalCurrent === 4 ||
            totalCurrent === 32 ||
            totalCurrent === 33 ||
            totalCurrent === 34 ||
            totalCurrent === 42 ||
            totalCurrent === 43 ||
            totalCurrent === 44 ||
            totalCurrent === 52 ||
            totalCurrent === 53 ||
            totalCurrent === 54 ||
            totalCurrent === 62 ||
            totalCurrent === 63 ||
            totalCurrent === 64 ||
            totalCurrent === 72 ||
            totalCurrent === 73 ||
            totalCurrent === 74 ||
            totalCurrent === 82 ||
            totalCurrent === 83 ||
            totalCurrent === 84 ||
            totalCurrent === 92 ||
            totalCurrent === 93 ||
            totalCurrent === 94 ||
            totalCurrent === 102 ||
            totalCurrent === 103 ||
            totalCurrent === 104 ||
            totalCurrent === 112 ||
            totalCurrent === 113 ||
            totalCurrent === 114 ||
            totalCurrent === 122 ||
            totalCurrent === 123 ||
            totalCurrent === 124 ||
            totalCurrent === 132 ||
            totalCurrent === 133 ||
            totalCurrent === 134 ||
            totalCurrent === 142 ||
            totalCurrent === 143 ||
            totalCurrent === 144 ||
            totalCurrent === 152 ||
            totalCurrent === 153 ||
            totalCurrent === 154 ||
            totalCurrent === 162 ||
            totalCurrent === 163 ||
            totalCurrent === 164
              ? 'ии'
              : 'ий'}{' '}
        </p>
      </div>
      {/* Передавать значения рабочего фильтра */}
      <div className={styles.wrapper_total_up}>
        <form className={styles.left} onSubmit={handleSubmit(onSearch)}>
          <div className={styles.filter_name}>Фильтр по вакансиям</div>
          <div className={[styles.left_item, styles.left_item_search].join(' ')} id="searchjob">
            <label className={styles.left_label} htmlFor='searchName'>
              Поиск
              <div
                className={
                  errors.positionName?.message ? styles.left_item_input_wrapper_error : styles.left_item_input_wrapper
                }
              >
                <input
                  className={[styles.left_item_input, 'placeholder-gray-400'].join(' ')}
                  name='searchName'
                  placeholder='Найти вакансию'
                  {...register('positionName')}
                  maxLength='100'
                />
                <img src={search_img} alt='search' />
              </div>
            </label>
          </div>
          <div className={styles.left_item_params}>
            <div className={styles.left_item}>
              <label className={styles.left_label} htmlFor='searchName'>
                Город
              </label>
              <Controller
                name="city"
                control={control}
                render={({ field: { onChange, value, name, ref } }) => (
                  <Select
                    ref={selectInputRefCities}
                    placeholder={'Все города'}
                    name={name}
                    value={citiesSelect.find((c) => c.value === value)}
                    className="reaction-select_container"
                    classNamePrefix="react-select"
                    // defaultValue={null}
                    hideSelectedOptions={false}
                    onChange={(val) => {onChange(val.value);}}
                    options={citiesSelect}
                    components={{
                      Option: InputOption
                    }}
                  />
                )}
              />
            </div>
            {unitNameShow && (
            <div className={styles.left_item}>
              <label className={styles.left_label} htmlFor='searchName'>
                Подразделение
              </label>
              <Controller
                name="unitName"
                control={control}
                render={({ field: { onChange, value, name, ref } }) => (
                  <Select
                    ref={selectInputRefDepartaments}
                    name={name}
                    value={departmentsSelect.find((c) => c.value === value)}
                    className="reaction-select_container"
                    classNamePrefix="react-select"
                    placeholder={'Все подразделения'}
                    hideSelectedOptions={false}
                    onChange={(val) => {onChange(val.value);}}
                    options={departmentsSelect}
                    components={{
                      Option: InputOption
                    }}
                  />
                )}
              />
            </div>
            )}

            <div className={styles.left_item}>
              <label className={styles.left_label} htmlFor='searchName'>
                Направление
              </label>
              <Controller
                name="unitDirectionName"
                control={control}
                render={({ field: { onChange, value, name, ref } }) => (
                  <Select
                    ref={selectInputRefDirections}
                    name={name}
                    value={directionsSelect.find((c) => c.value === value)}
                    className="reaction-select_container"
                    classNamePrefix="react-select"
                    placeholder={'Все направления'}
                    hideSelectedOptions={false}
                    onChange={(val) => {onChange(val.value);}}
                    options={directionsSelect}
                    components={{
                      Option: InputOption
                    }}
                  />
                )}
              />
            </div>

            <div className={styles.left_item}>
              <label className={styles.left_label} htmlFor='searchName'>
                Тип занятости
              </label>
              <Controller
                name="employment"
                control={control}
                render={({ field: { onChange, value, name, ref } }) => (
                  <Select
                    ref={selectInputRefEployment}
                    name={name}
                    value={eploymentSelect.find((c) => c.value === value)}
                    className="reaction-select_container"
                    classNamePrefix="react-select"
                    placeholder={'Любой'}
                    hideSelectedOptions={false}
                    onChange={(val) => {onChange(val.value);}}
                    options={eploymentSelect}
                    components={{
                      Option: InputOption
                    }}
                  />
                )}
              />
            </div>
          </div>

          <div className={styles.search_btn_wrap}>
            <button className={[styles.search_btn, styles.search_btn_apply].join(' ')} type='submit'>
              Применить
            </button>
            <div className={[styles.search_btn, styles.search_btn_cancel].join(' ')} onClick={clearFilter}>
              Сбросить
            </div>
          </div>
          {/* <a className={styles.left_banner} href="https://rating.hh.ru/poll" target="_blank">
            <img src={bannerHh} alt=""/>
          </a> */}
        </form>

        <div className={styles.right}>
          <div className={styles.right_wrapper}>
            {notOpenVacation && (
              <p className={styles.right_wrapper_noVacation}>Нет открытых вакансий по вашему направлению</p>
            )}

            {/*если вакансий нет по поиску*/}
            {vacationSort.length === 0 && searchSuccess && (
              <div className={styles.right_wrapper_notFoundVacation_wrapper}>
                <p className={styles.right_wrapper_notFoundVacation_wrapper_p1}>
                  Мы не смогли найти открытых вакансий по вашему запросу
                </p>
                <p className={styles.right_wrapper_notFoundVacation_wrapper_p2}>
                  Попробуйте изменить один из фильтров — это расширит область поиска
                </p>
                <div className={styles.right_wrapper_filter}>
                  {infoCity && (
                    <div className={styles.right_wrapper_filter_item}>
                      <div className='flex items-center'>
                        {infoCity}
                        {/*<p>+20 вакансий</p>*/}
                      </div>
                      <img onClick={deleteFieldCity} src={cross} alt='cross' />
                    </div>
                  )}

                  {infoLocation && (
                    <div className={styles.right_wrapper_filter_item}>
                      <div className='flex items-center'>{infoLocation}</div>
                      <img onClick={deleteFieldLocation} src={cross} alt='cross' />
                    </div>
                  )}

                  {infoDirection && (
                    <div className={styles.right_wrapper_filter_item}>
                      <div className='flex items-center'>{infoDirection}</div>
                      <img onClick={deleteFieldDirection} src={cross} alt='cross' />
                    </div>
                  )}

                  {infoEmploymentType && (
                    <div className={styles.right_wrapper_filter_item}>
                      <div className='flex items-center'>{infoEmploymentType}</div>
                      <img onClick={deleteFieldEmploymentType} src={cross} alt='cross' />
                    </div>
                  )}

                  {infoIsRemote && (
                    <div className={styles.right_wrapper_filter_item}>
                      <div className='flex items-center'>
                        Удаленно
                        {/*<p>+20 вакансий</p>*/}
                      </div>
                      <img onClick={deleteFieldIsRemote} src={cross} alt='cross' />
                    </div>
                  )}
                </div>

                <div className={styles.last_title_container}>
                  <p className={styles.last_title}>Последние вакансии</p>
                </div>

                {filterVacation
                  ?.filter((vacation, index) => index < currentSizeNoSort)
                  .map((item, index) => (
                    <div key={item?.id} className={[styles.wrapper_global, "wrapper_global"].join(' ')}>
                      <React.Fragment>
                        <div className={styles.wrapper_text_right}>
                          <div className={styles.title_wrap}>
                            <p className={styles.workshop}>{item?.workshop}</p>
                            <Link
                              className={styles.title}
                              to={'/listing/jobs' + `/id=${item.id}`}
                              state={{
                                itemVacation: item,
                                route: '/listing',
                                pageId: '/listing/jobs' + `/id=${item.id}`,
                                infoSearch: infoDataFilter
                              }}
                            >
                              <svg
                                width='8'
                                height='9'
                                viewBox='0 0 8 9'
                                xmlns={circle}
                                className={styles.wrapper_text_right_circle}
                              >
                                <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                              </svg>
                              <p>{item?.positionName}</p>
                            </Link>
                          </div>
                          <div className={styles.information_wrapper}>
                            <div className={styles.info_item}>
                              <p className={styles.info_item_title}>Опыт работы</p>
                              <p className={styles.info_item_text}>{item?.experience}</p>
                            </div>
                            <div className={styles.info_item}>
                              <p className={styles.info_item_title}>Локация</p>
                              <p className={styles.info_item_text}>{item?.city.name}</p>
                            </div>
                            <div className={[styles.info_item, styles.info_item_employment].join(' ')}>
                              <p className={styles.info_item_title}>Тип занятости</p>
                              <p className={styles.info_item_text}>{item?.employmentType}</p>
                            </div>
                            <Link
                              className={styles.more_wrap}
                              to={'/listing/jobs' + `/id=${item.id}`}
                              state={{
                                itemVacation: item,
                                route: '/listing',
                                pageId: '/listing/jobs' + `/id=${item.id}`
                              }}
                            >
                              <p className={styles.more_text}>Подробнее</p>
                              <p className={styles.more_arrow}>&rarr;</p>
                            </Link>
                          </div>
                        </div>

                        {/* {index === 1 && (
                          <div className={styles.right_wrapper_advertising}>
                            <div className={styles.advertising_left}>
                              <div className={styles.advertising_left_wrapper}>
                                <svg
                                  width='8'
                                  height='9'
                                  viewBox='0 0 8 9'
                                  xmlns={circle}
                                  className={styles.wrapper_text_right_circle2}
                                >
                                  <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                                </svg>
                                <p>
                                  Учитесь новому с Generium
                                </p>
                              </div>
                              <p>
                                Получить практику работы в компании вы можете ещё до окончания вуза. Мы
                                разработали образовательные программы с ведущими вузами страны и запустили
                                сезонные стажировки в&nbsp;R&D и на производстве.
                              </p>
                              <Link to='/students/education' className={styles.advertising_btn_bott}>
                                Узнать больше <span> &rarr;</span>
                              </Link>
                            </div>
                            <div className={styles.advertising_img_wrap}>
                              <img src={banner} className={styles.advertising_img} alt='banner' />
                            </div>
                          </div>
                        )} */}
                      </React.Fragment>
                    </div>
                  ))}
                {currentSizeNoSort <= allVacationNoSort?.length && (
                  <button className={styles.vacancion_block_listing_btn} onClick={plusVacationNoSort}>
                    Показать еще <span>&darr;</span>
                  </button>
                )}
              </div>
            )}

            {/*Если вакансиии успешно найдены */}
            {vacationSort.length > 0 && searchSuccess && (
              <>
                {vacationSort &&
                  vacationSort.map((item, index) => (
                    <div key={item?.id} className={[styles.wrapper_global, "wrapper_global"].join(' ')}>
                      {/*<div className={styles.wrapper_up}>*/}
                      {/*  <p className={styles.right_title}>{item?.unitName}</p>*/}
                      {/*</div>*/}
                      <React.Fragment>
                        <div className={styles.wrapper_text_right}>
                          <div className={styles.title_wrap}>
                            <p className={styles.workshop}>{item?.workshop}</p>
                            <Link
                              className={styles.title}
                              to={'/listing/jobs' + `/id=${item.id}`}
                              state={{
                                itemVacation: item,
                                route: '/listing',
                                pageId: '/listing/jobs' + `/id=${item.id}`,
                                infoSearch: infoDataFilter
                              }}
                              onClick={() => setInfoVacationRetakePage(infoDataFilter)}
                            >
                              <svg
                                width='8'
                                height='9'
                                viewBox='0 0 8 9'
                                xmlns={circle}
                                className={styles.wrapper_text_right_circle}
                              >
                                <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                              </svg>
                              <p>{item?.positionName}</p>
                            </Link>
                          </div>
                          <div className={styles.information_wrapper}>
                            <div className={styles.info_item}>
                              <p className={styles.info_item_title}>Опыт работы</p>
                              <p className={styles.info_item_text}>{item?.experience}</p>
                            </div>
                            <div className={styles.info_item}>
                              <p className={styles.info_item_title}>Локация</p>
                              <p className={styles.info_item_text}>{item?.city.name}</p>
                            </div>
                            <div className={[styles.info_item, styles.info_item_employment].join(' ')}>
                              <p className={styles.info_item_title}>Тип занятости</p>
                              <p className={styles.info_item_text}>{item?.employmentType}</p>
                            </div>
                            <Link
                              className={styles.more_wrap}
                              to={'/listing/jobs' + `/id=${item.id}`}
                              state={{
                                itemVacation: item,
                                route: '/listing',
                                pageId: '/listing/jobs' + `/id=${item.id}`
                              }}
                            >
                              <p className={styles.more_text}>Подробнее</p>
                              <p className={styles.more_arrow}>&rarr;</p>
                            </Link>
                          </div>
                        </div>

                        {/* {index === 1 && (
                          <div className={styles.right_wrapper_advertising}>
                            <div className={styles.advertising_left}>
                              <div className={styles.advertising_left_wrapper}>
                                <svg
                                  width='8'
                                  height='9'
                                  viewBox='0 0 8 9'
                                  xmlns={circle}
                                  className={styles.wrapper_text_right_circle2}
                                >
                                  <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                                </svg>
                                <p>
                                  Учитесь новому с Generium
                                </p>
                              </div>
                              <p>
                                Получить практику работы в компании вы можете ещё до окончания вуза. Мы
                                разработали образовательные программы с ведущими вузами страны и запустили
                                сезонные стажировки в&nbsp;R&D и на производстве.
                              </p>
                              <Link to='/students/education' className={styles.advertising_btn_bott}>
                                Узнать больше <span> &rarr;</span>
                              </Link>
                            </div>
                            <div className={styles.advertising_img_wrap}>
                              <img src={banner} className={styles.advertising_img} alt='banner' />
                            </div>
                          </div>
                        )} */}
                      </React.Fragment>
                    </div>
                  ))}
                {!disableBtn && !closeBtnDep && (
                  <button className={styles.vacancion_block_listing_btn} onClick={getNewPageSort}>
                    Показать еще <span> &darr;</span>
                  </button>
                )}
              </>
            )}

            {/*Если поиск не производился*/}
            {allVacationNoSort && !searchSuccess && (
              <>
                {allVacationNoSort &&
                  allVacationNoSort
                    ?.filter((elem, index) => index < startVacation)
                    .map((item, index) => (
                      <div key={item?.id} className={[styles.wrapper_global, "wrapper_global"].join(' ')}>
                        <div className={styles.wrapper_up}>
                          <p className={styles.right_title}>{item?.unitDirectionName}</p>
                        </div>
                        {/* строка с вакансией */}
                        {item &&
                          item?.positionInfos?.filter((pos, index) => index < 4).map((list, i) => (
                            <React.Fragment key={list.id}>
                              <div className={styles.wrapper_text_right}>
                                <div class={styles.title_wrap}>
                                  <p className={styles.workshop}>{list?.workshop}</p>
                                  <Link
                                    className={styles.title}
                                    to={'/listing/jobs' + `/id=${list.positionId}`}
                                    state={{
                                      itemVacation: list,
                                      route: '/listing',
                                      pageId: '/listing/jobs' + `/id=${list.positionId}`
                                    }}
                                  >
                                    <svg
                                      width='8'
                                      height='9'
                                      viewBox='0 0 8 9'
                                      xmlns={circle}
                                      className={styles.wrapper_text_right_circle}
                                    >
                                      <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                                    </svg>
                                    <p>{list?.positionName}</p>
                                  </Link>
                                </div>
                                <div className={styles.information_wrapper}>
                                  <div className={styles.info_item}>
                                    <p className={styles.info_item_title}>Опыт работы</p>
                                    <p className={styles.info_item_text}>{list?.experience}</p>
                                  </div>
                                  <div className={styles.info_item}>
                                    <p className={styles.info_item_title}>Локация</p>
                                    <p className={styles.info_item_text}>{list?.city?.name}</p>
                                  </div>
                                  <div className={[styles.info_item, styles.info_item_employment].join(' ')}>
                                    <p className={styles.info_item_title}>Тип занятости</p>
                                    <p className={styles.info_item_text}>{list?.employmentType}</p>
                                  </div>
                                  <Link
                                    className={styles.more_wrap}
                                    to={'/listing/jobs' + `/id=${list.positionId}`}
                                    state={{
                                      itemVacation: list,
                                      route: '/listing',
                                      pageId: '/listing/jobs' + `/id=${list.positionId}`
                                    }}
                                  >
                                    <p className={styles.more_text}>Подробнее</p>
                                    <p className={styles.more_arrow}>&rarr;</p>
                                  </Link>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        {/*Вывод кнопки показать все вакансии направления*/}
                        {item && item?.positionInfos.length > 4 && (
                          <div className={styles.vacancion_block_listing_btn} onClick={() => searchDirections(item)}>
                            Все вакансии направления <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9 12L13 8M13 8L9 4M13 8L3 8" stroke="#202020" stroke-width="1.28"/>
                                  </svg>
                              </span>
                          </div>
                        )}
                        {/* {index === 0 && (
                          <div className={styles.right_wrapper_advertising}>
                            <div className={styles.advertising_left}>
                              <div className={styles.advertising_left_wrapper}>
                                <svg
                                  width='8'
                                  height='9'
                                  viewBox='0 0 8 9'
                                  xmlns={circle}
                                  className={styles.wrapper_text_right_circle2}
                                >
                                  <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                                </svg>
                                <p>
                                  Учитесь новому с Generium
                                </p>
                              </div>
                              <p>
                                Получить практику работы в компании вы можете ещё до окончания вуза. Мы
                                разработали образовательные программы с ведущими вузами страны и запустили
                                сезонные стажировки в&nbsp;R&D и на производстве.
                              </p>
                              <Link to='/students/education' className={styles.advertising_btn_bott}>
                                Узнать больше <span> &rarr;</span>
                              </Link>
                            </div>
                            <div className={styles.advertising_img_wrap}>
                              <img src={banner} className={styles.advertising_img} alt='banner' />
                            </div>
                          </div>
                        )} */}
                      </div>
                    ))}
                {startVacation <= allVacationNoSort?.length && (
                  <button className={styles.vacancion_block_listing_btn} onClick={plusStartVacation}>
                    Показать еще <span> &darr;</span>
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div className={styles.wrapper_total_down}>
        <div className={styles.wrapper_total_left}>Станьте частью команды Generium</div>
        <div className={styles.wrapper_total_right}>
          <div className={styles.wrapper_total_text}>
            <p className={styles.wrapper_total_text_p2}>
              <span>→</span> Хочу работать в команде
            </p>
          </div>
          <div className={styles.wrapper_total_content}>
            {/*  form block */}
            <div className={styles.form_block_wrapper}>
              <div className={styles.form_block_image_wrap}>
                <img src={form_image} className={styles.form_block_image} alt='form_image' />
              </div>
              {!successForm && (
                <div className={styles.form_block_container}>
                  <FormVacation checkDomenNameState={checkDomenNameState} setSuccessForm={setSuccessForm} captchaSiteKey={captchaSiteKey} />
                </div>
              )}
              {successForm && (
                <div className={styles.wrapper_total_right_success}>
                  <p className={styles.wrapper_total_right_success_p1}>
                    Спасибо за интерес <br/> к&nbsp;компании Generium!
                  </p>
                  <p>Мы свяжемся с вами в случае соответствия резюме требованиям вакансии.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Listing
